<template>
  <div class="animated fadeIn">
    <div class="box">
      <div class="p-20">
        <div>Wristband Registration</div>
        <hr class="short-line left mb-20">
        <form @submit.prevent="validateWristband('wristband')" data-vv-scope="wristband">
          <div class="row justify-content-center mt-30">
            <div class="col-sm-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Member ID</label>
                </b-col>
                <b-col sm="9">
                  <div class="custom-search-select">
                    <model-select @searchchange="searchMember" :options="optionsMember" class="border-bottom" name="member_id" v-validate="'required'" v-model="registerWristband.member_id"></model-select>
                  </div>
                  <span class="error">{{ errors.first('wristband.member_id') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Member Name</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="border-bottom bg-transparent" disabled v-model="fullNameDetail" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Phone Number</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="border-bottom bg-transparent" disabled v-model="detailMember.phone_number" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Email</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="border-bottom bg-transparent" disabled v-model="detailMember.email" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Membership Type</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="border-bottom bg-transparent" disabled v-model="detailMember.membership_last_buy_name" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Join Date</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="border-bottom bg-transparent" disabled v-model="detailMember.start_membership" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-sm-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>RFID Card Code</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input name="rfid_card_code" v-validate="'required'" class="border-bottom" v-model="registerWristband.rfid_card_code" type="text"></b-form-input>
                  <span class="error">{{ errors.first('wristband.rfid_card_code') }}</span>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="text-right">
            <button type="submit" class="btn-primary">Submit</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import { ModelSelect } from 'vue-search-select'
import Mixin from '../../mixins/memberMixin'
export default {
  name: 'regisWristband',
  components: {
    ModelSelect
  },
  mixins:[Mixin],
  data: function () {
    return {
      dataMember: [],
      dataCS: [],
      config: {
        altInput: true,
        altFormat: 'F j, Y',
        dateFormat: 'Y-m-d'
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      money2: {
        decimal: ',',
        thousands: '.',
        prefix: 'IDR ',
        suffix: '',
        precision: 0,
        masked: false
      },
      formType: 'wristband',
      itemsPaymentCard: [],
      itemsPaymentType: [],
      detailMember: {},
      fullNameDetail: '',
      detailCS: {},
      CSName: '',
      modalShow: false,
      linkPrivyId: 'https://sandbox.privy.id/user',
      registerWristband: {
        member_id: null,
        rfid_card_code: ''
      },
      optionsMember: [
        { value: null, text: 'Please select' }
      ]
    }
  },
  methods: {
    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    getMemberData (event) {
      axios.get('fitness/v1/member/' + event).then(response => {
        this.detailMember = response.data.data
        this.fullNameDetail = response.data.data.first_name + ' ' + response.data.data.last_name
        this.addDataPrivy.branch_id = response.data.data.branch_id
        this.addDataPrivy.member_id = response.data.data.id
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
    },
    getCSData (event) {
      axios.get('crm/v1/customer_service/' + event).then(response => {
        this.detailCS = response.data.data
        this.CSName = response.data.data.name
        this.addDataPrivy.customer_id = response.data.data.id
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
    },
    formSelect (event) {
      return event
    },
    changeValueMoney (event) {
      if (!(event.key === '')) {
        this.$refs['error-print'].classList.add('hidden')
      } else {
        this.$refs['error-print'].classList.remove('hidden')
      }
    },
    validateWristband (data4) {
      // console.log(this.registerWristband)
      this.$validator.validateAll(data4).then((result) => {
        if(result) {
          axios.put('fitness/v1/member/' + this.registerWristband.member_id, this.registerWristband).then(response => {
            // console.log('test', response)
            this.$router.push('/allForm')
            this.$toast.success('Register Wristband Successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error log', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    fetchData() {
      this.getMember()
      // turn off autocomplete
      if(document.getElementsByTagName) {
        var inputElements = document.getElementsByTagName("member_id")
        for (var i=0; inputElements[i]; i++) {
          if (inputElements[i].className && (inputElements[i].className.indexOf("disableAutoComplete") != -1)) {
            inputElements[i].setAttribute("autocomplete","off")
          }
        }
      }
    }
  },
  computed: {
    getMemberId: function() {
      return this.registerWristband.member_id
    }
  },
  watch: {
    getMemberId () {
      axios.get('fitness/v1/member/' + this.registerWristband.member_id).then(response => {
        this.detailMember = response.data.data
        // console.log('liat data, ', response.data.data.rfid_card_code)
        if(response.data.data.rfid_card_code) {
          this.registerWristband.rfid_card_code = response.data.data.rfid_card_code
        }
        this.fullNameDetail = response.data.data.first_name + ' ' + response.data.data.last_name
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
